<pannel [title]="'Documents échangés et expliqués entre les entreprises'" [expandable]="true">

	<table mat-table [dataSource]="documentsEchange" class="analyse-table">
	
		<ng-container matColumnDef="libelle">
		<th mat-header-cell *matHeaderCellDef>Document</th>
		<td mat-cell *matCellDef="let doc">
			<mat-checkbox color="primary" [(ngModel)]="doc.checked" [disabled]="currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"></mat-checkbox> 
			{{ doc.libelle }}
		</td>
		</ng-container>
	
		<ng-container matColumnDef="responsabilite">
			<th mat-header-cell *matHeaderCellDef>Responsabilité</th>
			<td mat-cell *matCellDef="let doc">{{ doc.responsabilite }}</td>
		</ng-container>
	
		<ng-container matColumnDef="remarque">
			<th mat-header-cell *matHeaderCellDef>Remarque</th>
			<td mat-cell *matCellDef="let doc">{{ doc.remarque || '-' }}</td>
		</ng-container>
	
		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	
	</table>

</pannel>

<ng-container *ngIf="isPaLoaded">
<pannel [title]="'Présentation du site entre représentants de l\'EU et de l\'EE'" [expandable]="true">

	<div class="form-group row">
	    <label class="control-label col-md-2">Réalisée le:</label>
	    <div class="col-md-3">
	        <date-input [disabled]="currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"
	            id="dateFRealise"
	            [(localDate)]="documentPaEchange.presentationSite.dateRealisation"
	            (localDateChange)="evaluerFormulaire()">
	        </date-input>
	    </div>
	</div>
	
	<div class="form-group">
	   <label for="typeAcces" class="control-label col-md-2">Type*:</label>
	   <div class="col-sm-3">
	      <label class="radio-inline" *ngFor="let option of typeOptions; let indexOption = index">
	        <input type="radio" [disabled]="currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"
		       name="typeAcces"
		       [id]="'typeAcces_' + indexOption"
		       [value]="option.value"
		       [(ngModel)]="documentPaEchange.presentationSite.type"
		       [class.radio-highlight]="!documentPaEchange.presentationSite.type" />    
	         {{ option.label }}
	      </label>
	   </div>
	</div>
	
	<div class="form-group row">
		<label class="control-label col-md-2">Zone d'accès interdit:</label>
		<div class="col-md-4">
			<textarea id="realise" class="form-control" rows="4" maxlength="1024" placeholder="A préciser..." [(ngModel)]="documentPaEchange.presentationSite.zoneAccesInterdit" [disabled]="currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"></textarea>
		</div>
	</div>
	
	<div class="form-group row"> 
		<label class="control-label col-md-2">Particularité des installations:</label> 
		<div class="col-md-4">
			<textarea class="form-control" rows="4" maxlength="1024" placeholder="Zone inondable..." [(ngModel)]="documentPaEchange.presentationSite.particulariteInstallation" [disabled]="currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT"></textarea>
		</div>
	</div>
	
	<div class="form-group row">
		<label class="control-label col-md-2">Autres informations échangées:</label>
		<div class="col-md-4">
			<textarea class="form-control" rows="4" maxlength="1024" [(ngModel)]="documentPaEchange.presentationSite.conduiteATenir" [disabled]="currentPaInstance.etat == paEtats.SIGNE || currentPaInstance.etat == paEtats.SIGNE_PARTIELLEMENT" > </textarea> 
		</div>
	</div>

</pannel>
</ng-container>

<document-pa-step-actions [documentPaButtons]="actionButtons" (onButtonPressed)="performAction($event)"></document-pa-step-actions>